// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"dd6d99f6","488":"a0992603","552":"9db59ef9","671":"03a62244"}[chunkId] + ".chunk.js";
};